import * as React from 'react';
import { generatePath, useParams } from 'react-router-dom';
import { useCloseModal } from '@core/router';

import { CreateDeclarationProvider } from '../context';
import { CreateDeclaration } from '../containers';

export const CreateDeclarationPage = () => {
  const closeModal = useCloseModal();
  const { id } = useParams<{ id?: string }>();

  const handleClose = React.useCallback(() => {
    if (id) {
      closeModal(generatePath('/@next/declarations/:id', { id }));
    } else {
      closeModal('/@next/declarations');
    }
  }, [closeModal, id]);

  return (
    <CreateDeclarationProvider id={id} onClose={handleClose} onSubmitSucceed={handleClose}>
      <CreateDeclaration />
    </CreateDeclarationProvider>
  );
};
